import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { USER_TYPES, USER_TYPES_CATEGORIES } from "../constants/globals";
import {
  pendingRequestsApi,
  totalPendingEMoneyRequestsNumber,
  totalUnseenMessages,
} from "../apis";
import AccountsReviewIcon from "./Svgs/sidebarIcons/AccountsReviewIcon";
import TransactionIcon from "./Svgs/TransactionsIcon";
import AdminSidebarIcon from "./Svgs/sidebarIcons/AdminSidebarIcon";
import AnnouncementsIcon from "./Svgs/sidebarIcons/AnnouncementsIcon";
import RequestsSidebarIcon from "./Svgs/sidebarIcons/RequestsSidebarIcon";
import ReplaceEMoneySidebarIcon from "./Svgs/sidebarIcons/ReplaceEMoneySidebarIcon";
import SettlementsSidebarIcon from "./Svgs/sidebarIcons/SettlementsSidebarIcon";
import WalletMangmentIcon from "./Svgs/sidebarIcons/WalletMangmentIcon";
import ReportsIcon from "./Svgs/sidebarIcons/ReportsIcon";
import PartnersSidebarIcon from "./Svgs/sidebarIcons/PartnersSidebarIcon";
import DashboardSidebarIcon from "./Svgs/sidebarIcons/DashboardSidebarIcon";
import SidebarLinks from "./SidebarLinks";
import SidebarLinksForMobile from "./SidebarLinksForMobile";
import PackageManagementIcon from "./Svgs/sidebarIcons/PackageManagementIcon";
import CoursesManagementIcon from "./Svgs/sidebarIcons/CoursesManagementIcon";
import TreeIconSideBar from "./Svgs/sidebarIcons/TreeIconSideBar";
import AddNewCourseIconSidebar from "./Svgs/sidebarIcons/AddNewCourseIconSidebar";
import ManagementSidebarIcon from "./Svgs/sidebarIcons/ManagementSidebarIcon";
import AllRequestsSidebarIcon from "./Svgs/sidebarIcons/AllRequestsSidebarIcon";
import AllReportsSidebarIcon from "./Svgs/sidebarIcons/AllReportsSidebarIcon";

const Sidebar = () => {
  const { sidebarCollapsed, linksCollapsedForMobile } = useSelector(
    (state) => state.UI
  );
  const { loggedInUser } = useSelector((state) => state.Auth);
  const currentUserType = loggedInUser?.data?.model?.user_type_id;
  const [requestsNum, setRequestsNum] = useState(0);
  const [replaceNum, setReplaceNum] = useState(0);
  const [unseenMessages, setUnseenMessages] = useState(0);
  const currentClientCategory =
    loggedInUser?.data?.model?.client?.client_category_id;

  useEffect(() => {
    if (currentUserType === USER_TYPES.ADMIN) {
      const fetchRequestsNum = async () => {
        try {
          const response = await pendingRequestsApi();
          if (response.data.status) {
            setRequestsNum(response.data.data || 0);
          } else {
            console.error("Failed to fetch indicators:", response.data.message);
          }
        } catch (error) {
          console.error("Error fetching indicators:", error);
        }
      };

      const fetchReplaceNum = async () => {
        try {
          const response = await totalPendingEMoneyRequestsNumber();
          if (response.data.status) {
            setReplaceNum(response.data.data.totalPending || 0);
          } else {
            console.error(
              "Failed to fetch replace requests:",
              response.data.message
            );
          }
        } catch (error) {
          console.error("Error fetching replace requests:", error);
        }
      };

      const fetchTotalUnseenMessages = async () => {
        try {
          const response = await totalUnseenMessages();
          if (response.data.status) {
            setUnseenMessages(response.data.data || 0);
          } else {
            console.error(
              "Failed to fetch unseen messages counts:",
              response.data.message
            );
          }
        } catch (error) {
          console.error("Error fetching unseen messages counts:", error);
        }
      };
      fetchRequestsNum();
      fetchReplaceNum();
      fetchTotalUnseenMessages();
    }
  }, [currentUserType]);

  const getSidebarLinks = () => {
    switch (currentUserType) {
      case USER_TYPES.ADMIN:
        return [
          {
            title: "Admin",
            isCollapsable: true,
            heading: {
              title: "Admin",
              icon: <AdminSidebarIcon />,
            },
            links: [
              {
                icon: <DashboardSidebarIcon />,
                title: "Dashboard",
                link: "/",
              },
              {
                title: "Partners",
                link: "/partners-list",
                icon: <PartnersSidebarIcon />,
              },
              {
                title: "Accounts Review",
                link: "/accounts-review",
                icon: <AccountsReviewIcon />,
              },
              {
                title: "Announcements",
                link: "/announcements",
                icon: <AnnouncementsIcon />,
              },
              {
                title: "Transactions",
                link: "/transactions",
                icon: <TransactionIcon />,
              },
              {
                title: "Renew Subscription",
                link: "/renew-subscription",
                icon: <AccountsReviewIcon />,
              },
              {
                icon: "chat",
                title: `Messages (${unseenMessages})`,
                link: "/admin-messages",
              },

              {
                title: "Management",
                icon: <ManagementSidebarIcon />,
                isCollapsable: true,
                subLinks: [
                  {
                    title: "Settlements Management",
                    link: "/settlements",
                    icon: <SettlementsSidebarIcon />,
                  },
                  {
                    title: "Wallet Management",
                    link: "/wallet-management",
                    icon: <WalletMangmentIcon />,
                  },
                  {
                    title: "Package Management",
                    link: "/package-management",
                    icon: <PackageManagementIcon />,
                  },
                  {
                    title: "Courses Management",
                    link: "/courses-management",
                    icon: "school",
                  },
                  {
                    title: "Instructors Management",
                    link: "/instructors-management",
                    icon: <CoursesManagementIcon />,
                  },
                ],
              },
              {
                title: "Requests",
                icon: <AllRequestsSidebarIcon />,
                isCollapsable: true,
                subLinks: [
                  {
                    title: `Requests Emoney (${requestsNum})`,
                    link: "/requests",
                    icon: <RequestsSidebarIcon />,
                  },
                  {
                    title: `Replace Emoney (${replaceNum})`,
                    link: "/replace-emoney",
                    icon: <ReplaceEMoneySidebarIcon />,
                  },
                ],
              },
              {
                title: "Reports",
                icon: <AllReportsSidebarIcon />,
                isCollapsable: true,
                subLinks: [
                  {
                    title: "Enrollments",
                    link: "/reports",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Subscription",
                    link: "/renew-subscription-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Wallets",
                    link: "/wallets-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Deactivate History",
                    link: "/deactivate-history-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "PVs Transactions",
                    link: "/PV-transactions-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Direct E-Money",
                    link: "/direct-e-money-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Expired Subscription",
                    link: "/expired-subscription-report",
                    icon: <ReportsIcon />,
                  },
                ],
              },
            ],
          },
        ];
      case USER_TYPES.MODERATOR:
        return [
          {
            title: "Moderator",
            isCollapsable: true,
            heading: {
              icon: <AdminSidebarIcon />,
              title: "Moderator",
            },
            links: [
              {
                icon: <DashboardSidebarIcon />,
                title: "Dashboard",
                link: "/",
              },
              {
                title: "Partners",
                link: "/partners-list",
                icon: <PartnersSidebarIcon />,
              },
              {
                title: "Accounts Review",
                link: "/accounts-review",
                icon: <AccountsReviewIcon />,
              },
              {
                title: "Announcements",
                link: "/announcements",
                icon: <AnnouncementsIcon />,
              },
              {
                title: "Transactions",
                link: "/transactions",
                icon: <TransactionIcon />,
              },
              {
                title: "Renew Subscription",
                link: "/renew-subscription",
                icon: <AccountsReviewIcon />,
              },

              {
                icon: "chat",
                title: "Messages",
                link: "/admin-messages",
              },

              {
                title: "Management",
                icon: <ManagementSidebarIcon />,
                isCollapsable: true,
                subLinks: [
                  {
                    title: "Settlements Management",
                    link: "/settlements",
                    icon: <SettlementsSidebarIcon />,
                  },
                  {
                    title: "Wallet Management",
                    link: "/wallet-management",
                    icon: <WalletMangmentIcon />,
                  },
                  {
                    title: "Package Management",
                    link: "/package-management",
                    icon: <PackageManagementIcon />,
                  },
                  {
                    title: "Courses Management",
                    link: "/courses-management",
                    icon: "school",
                  },
                  {
                    title: "Instructors Management",
                    link: "/instructors-management",
                    icon: <CoursesManagementIcon />,
                  },
                ],
              },
              {
                title: "Reports",
                icon: <AllReportsSidebarIcon />,
                isCollapsable: true,
                subLinks: [
                  {
                    title: "Enrollments",
                    link: "/reports",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Subscription",
                    link: "/renew-subscription-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Wallets",
                    link: "/wallets-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Deactivate History",
                    link: "/deactivate-history-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "PVs Transactions",
                    link: "/PV-transactions-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Direct E-Money",
                    link: "/direct-e-money-report",
                    icon: <ReportsIcon />,
                  },
                  {
                    title: "Expired Subscription",
                    link: "/expired-subscription-report",
                    icon: <ReportsIcon />,
                  },
                ],
              },
            ],
          },
        ];
      case USER_TYPES.PARTNER:
        if (
          currentClientCategory === USER_TYPES_CATEGORIES.SERVICE_ONLY ||
          currentClientCategory === USER_TYPES_CATEGORIES.NEWCOMER
        ) {
          return [
            {
              isCollapsable: true,
              heading: {
                icon: "public",
                title: "Explore",
              },
              links: [
                {
                  icon: <DashboardSidebarIcon />,
                  title: "Home",
                  link: "/",
                },
                {
                  icon: "library_books",
                  title: "My Courses",
                  link: "/partners/my-courses",
                },
                {
                  icon: "chat",
                  title: "Messages",
                  link: "/messages",
                },
              ],
            },
          ];
        } else {
          return [
            {
              title: "Partners",
              isCollapsable: true,
              heading: {
                icon: <AdminSidebarIcon />,
                title: "Partners",
              },
              links: [
                {
                  icon: <DashboardSidebarIcon />,
                  title: "Dashboard",
                  link: "/",
                },
                {
                  icon: <PartnersSidebarIcon />,
                  title: "Partners List",
                  link: "/partners-list",
                },
                { icon: <TreeIconSideBar />, title: "Tree", link: "/tree" },
                {
                  icon: "person_add",
                  title: "Add New Partner",
                  link: "/partners/add",
                },
                {
                  icon: <RequestsSidebarIcon />,
                  title: "Request E-Money",
                  link: "/partners/request-e-money",
                },
                {
                  icon: <TransactionIcon />,
                  title: "Transfer E-Money",
                  link: "/partners/transfer-e-money",
                },
                {
                  icon: <ReplaceEMoneySidebarIcon />,
                  title: "Replace E-Money",
                  link: "/partners/replace-e-money",
                },
                {
                  icon: <AddNewCourseIconSidebar />,
                  title: "Add New Course",
                  link: "/partners/add-new-course",
                },
                {
                  icon: "library_books",
                  title: "My Courses",
                  link: "/partners/my-courses",
                },
                {
                  title: "Transactions",
                  link: "/transactions",
                  icon: <TransactionIcon />,
                },
                {
                  title: "My Vouchers",
                  link: "/my-vouchers-list",
                  icon: "card_giftcard",
                },
                {
                  icon: "chat",
                  title: "Messages",
                  link: "/messages",
                },
              ],
            },
          ];
        }
      default:
        return [];
    }
  };

  const sidebarLinks = getSidebarLinks();

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      {isSmallScreen ? (
        <SidebarLinksForMobile
          linksCollapsedForMobile={linksCollapsedForMobile}
          sidebarLinks={sidebarLinks}
        />
      ) : (
        <SidebarLinks
          sidebarLinks={sidebarLinks}
          sidebarCollapsed={sidebarCollapsed}
        />
      )}
    </div>
  );
};

export default Sidebar;
